import { AfterViewInit, Component, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { AbstractControl, ControlContainer, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import * as _ from "underscore"

@Component({
  selector: 'form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: FormErrorComponent,
    multi: true
}]
})
export class FormErrorComponent implements ControlValueAccessor, AfterViewInit {

  public theError: string;
  public errors: any = {}
  public _errors:any[] = []
  private control: AbstractControl;

  @Input() formControlName: string = "";

  constructor(
    @Optional() @Host() @SkipSelf()
    private controlContainer: ControlContainer
  ) {

  }

  ngAfterViewInit(): void {

    if (this.controlContainer) {
      if (this.formControlName) {

        this.control = this.controlContainer.control.get(this.formControlName);

        this.control.valueChanges.subscribe(() => {
          this.buildErrors()
        })
      } else {
        console.warn('Missing FormControlName directive from host element of the component');
      }
    } else {
      console.warn('Can\'t find parent FormGroup directive');
    }

  }

  buildErrors() {
    const errors = []
    this.errors = this.control.errors
    // console.log(this.errors)
    if (this.errors?.required) {
      errors.push("Ce champ est requis")
      delete this.errors.required
    }
    if (this.errors?.email) {
      errors.push("Cet email n'est pas valable")
      delete this.errors.email
    }
    const vals = _.values(this.errors)
    errors.push(...vals)
    this._errors = errors
    this.theError = this._errors.join(" & ")
  }

  writeValue(obj: any): void {

  }
  registerOnChange(fn: any): void {

  }
  registerOnTouched(fn: any): void {

  }

}
